import { render, staticRenderFns } from "./ModalKardexAsimilado.vue?vue&type=template&id=22fb6835&scoped=true"
import script from "./ModalKardexAsimilado.vue?vue&type=script&lang=js"
export * from "./ModalKardexAsimilado.vue?vue&type=script&lang=js"
import style0 from "./ModalKardexAsimilado.vue?vue&type=style&index=0&id=22fb6835&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fb6835",
  null
  
)

export default component.exports